import React from "react";
import compose from "recompose/compose";
import AccountNavigation from "theme/layouts/Header/Navigation/AccountNavigation/AccountNavigation";
import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";
import StoreViewSelector from "theme/modules/User/StoreViewSelector";
import MiniCartIcon from "theme/modules/Cart/MiniCart/MiniCartIcon";

const Navigation = ({
  userData,
  selectMenu,
  renderSubNav,
  storeView,
  canDisplayLinkOnListing,
}) => {
  const cartLength = userData?.cart?.items_qty ?? null;

  if (
    typeof canDisplayLinkOnListing === "undefined" ||
    canDisplayLinkOnListing === "undefined"
  ) {
    canDisplayLinkOnListing = true;
  }

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        <li className="navigation__item navigation__item--store-view desktop-only">
          <StoreViewSelector storeView={storeView} />
        </li>

        <li className="navigation__item">
          <AccountNavigation
            loading={userData?.loading ?? true}
            user={userData?.me}
            selectMenu={selectMenu}
            renderSubNav={renderSubNav}
          />
        </li>

        <MiniCartIcon
          canDisplayLinkOnListing={canDisplayLinkOnListing}
          cartLength={cartLength}
          selectMenu={selectMenu}
          renderSubNav={renderSubNav}
        />
      </ul>
    </nav>
  );
};

export default compose(withIsFeatureActive("wishlistFeature", "wishlist"))(
  Navigation
);
